<script setup>
import {ref} from 'vue'
import {useItemDataStore} from '@/stores/itemData'
import {useAppStore} from '@/stores/appStore'

const props = defineProps({
    value: Number
})

const itemDataStore = useItemDataStore()
const appStore = useAppStore()

const href = ref('')
const fileName = ref('')

// Initialization logic
itemDataStore.get({
        tableName: 'files',
        id: props.value
    })
    .then((obj) => {
        if (obj) {
            href.value = appStore.fileSrc(obj.fileName)
            fileName.value = obj.fileName
        }
    })
</script>

<template>
    <a v-if="href" :href="href" :title="fileName">{{ fileName }}</a>
</template>